import React, { useState } from 'react';
import axios from 'axios';
import { API } from '@/App';
import Navbar from '@/components/Navbar';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { toast } from 'sonner';
import { Mail, Phone } from 'lucide-react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      await axios.post(`${API}/commissions`, formData);
      toast.success('Your inquiry has been sent! We\'ll be in touch soon.');
      setFormData({ name: '', email: '', message: '' });
    } catch (error) {
      console.error('Failed to send inquiry:', error);
      toast.error('Failed to send inquiry. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-5xl font-bold text-center mb-4 bg-gradient-to-r from-teal-500 to-pink-500 bg-clip-text text-transparent">
          Custom Commissions
        </h1>
        <p className="text-center text-gray-600 mb-12">Let's bring your vision to life</p>
        
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
          <form onSubmit={handleSubmit} className="space-y-6" data-testid="commission-form">
            <div>
              <label className="block text-sm font-semibold mb-2 text-gray-700">Name</label>
              <Input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
                placeholder="Your name"
                data-testid="commission-name-input"
                className="w-full"
              />
            </div>
            
            <div>
              <label className="block text-sm font-semibold mb-2 text-gray-700">Email</label>
              <Input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
                placeholder="your.email@example.com"
                data-testid="commission-email-input"
                className="w-full"
              />
            </div>
            
            <div>
              <label className="block text-sm font-semibold mb-2 text-gray-700">Message</label>
              <Textarea
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                required
                placeholder="Tell us about your vision, preferred colors, size, and any other details..."
                rows={6}
                data-testid="commission-message-input"
                className="w-full"
              />
            </div>
            
            <Button 
              type="submit" 
              disabled={loading}
              className="w-full bg-gradient-to-r from-teal-500 to-pink-500 hover:from-teal-600 hover:to-pink-600 text-white py-6 text-lg rounded-full"
              data-testid="commission-submit-btn"
            >
              {loading ? 'Sending...' : 'Send Inquiry'}
            </Button>
          </form>
          
          <div className="mt-12 pt-8 border-t border-gray-200">
            <h3 className="text-xl font-bold mb-6 text-center">Get In Touch</h3>
            <div className="flex flex-col md:flex-row gap-6 justify-center items-center">
              <a 
                href="mailto:Azart@Fluidfusionaz.com" 
                className="flex items-center gap-3 text-gray-700 hover:text-teal-600 transition-colors"
              >
                <Mail className="h-5 w-5 text-teal-500" />
                <span className="text-lg">Azart@Fluidfusionaz.com</span>
              </a>
              <a 
                href="tel:4807446639" 
                className="flex items-center gap-3 text-gray-700 hover:text-teal-600 transition-colors"
              >
                <Phone className="h-5 w-5 text-teal-500" />
                <span className="text-lg">(480) 744-6639</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;